import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckOutlined } from '@ant-design/icons';
import { Tariffs } from 'components/TariffsComponent/tariffsData';
import { IDataRoom } from 'interfaces';
import RowLoader from 'components/Sceletons/RowLoader';
import classes from './PlanDetailsCard.module.scss';

type PlanDetailsCardProps = {
  room?: IDataRoom | null;
  planName?: string;
  isLoading?: boolean;
};

const getTariffProfileName = (tariff: IDataRoom['tariff']) => {
  if (tariff?.tariff_name === 'profile') {
    return tariff.type;
  }
  return tariff?.tariff_name;
};

const PlanDetailsCard = ({ room, planName, isLoading }: PlanDetailsCardProps) => {
  const { t } = useTranslation();
  const tariff = room?.tariff;
  const constraints = tariff?.constraints;
  const isTrial = tariff?.tariff_name === Tariffs.Trial;

  const displayName =
    planName || t(`Tariffs.tariff_name.${getTariffProfileName(tariff)}`);

  return (
    <div className={classes.card}>
      <div className={classes.header}>
        <span className={classes.headerLabel}>
          {t('planDetails.title')}
        </span>
        {isLoading ? (
          <RowLoader width='120px' padding='0' height='18px' />
        ) : (
          <span className={classes.headerTariff}>{displayName}</span>
        )}
      </div>

      {(isLoading || !isTrial) && (
        <div className={classes.row}>
          <span className={classes.rowLabel}>{t('planDetails.price')}</span>
          {isLoading ? (
            <RowLoader width='160px' padding='0' height='20px' />
          ) : (
            <span className={classes.rowValue}>
              <b className={classes.price}>
                {Number(tariff?.cost || 0).toLocaleString()}
              </b>
              <span className={classes.currency}>{tariff?.currency}</span>
              <span className={classes.separator}>/</span>
              <span className={classes.duration}>
                {tariff?.duration || 1}{' '}
                {t(`planDetails.duration.${tariff?.duration_unit || 'MONTH'}`)}
              </span>
            </span>
          )}
        </div>
      )}

      {(isLoading || constraints) && (
        <div className={classes.row}>
          <span className={classes.rowLabel}>
            {t('planDetails.included')}
          </span>
          {isLoading ? (
            <div className={classes.includedList}>
              <RowLoader width='180px' padding='0' height='16px' />
              <RowLoader width='160px' padding='0' height='16px' />
              <RowLoader width='170px' padding='0' height='16px' />
            </div>
          ) : (
            <ul className={classes.includedList}>
              {constraints?.storage !== undefined && constraints?.storage !== null && (
                <li>
                  <CheckOutlined className={classes.check} />
                  <span>
                    {constraints.storage} {t('Tariffs.gb')}{' '}
                    {t('planDetails.storage')}
                  </span>
                </li>
              )}
              {constraints?.members !== undefined && constraints?.members !== null && (
                <li>
                  <CheckOutlined className={classes.check} />
                  <span>
                    {t('Tariffs.number_of_users_count', {
                      count: constraints.members,
                    })}
                  </span>
                </li>
              )}
              {constraints?.rooms !== undefined && constraints?.rooms !== null && (
                <li>
                  <CheckOutlined className={classes.check} />
                  <span>
                    {t('planDetails.roomsCount', { count: constraints.rooms })}
                  </span>
                </li>
              )}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default PlanDetailsCard;
